export default {"src":"/_next/static/media/alert-danger.58634c61.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};